import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export interface ChipProps {
  className?: string;
  color?: 'default' | 'none' | 'primary';
  fontWeight?: 'default' | 'none';
  title?: string;
}

type ChipClassName = HTMLAttributes<HTMLDivElement>['className'];

export function Chip(props: React.PropsWithChildren<ChipProps>) {
  const { color = 'default', fontWeight = 'default', title } = props;

  // color class
  let colorClass: ChipClassName = color !== 'none' ? undefined : undefined;
  if (color === 'default') {
    colorClass = classNames(colorClass, 'bg-gray-100 dark:bg-gray-900 text-gray-600 dark:text-gray-300');
  } else if (color === 'primary') {
    colorClass = classNames(colorClass, 'bg-sky-500 dark:bg-sky-300 text-gray-100 dark:text-gray-800');
  }

  return (
    <div
      className={classNames(
        props.className,
        'inline-block rounded-full px-2 text-sm text-center',
        fontWeight === 'default' && 'font-normal',
        colorClass
      )}
      title={title}
    >
      {props.children}
    </div>
  );
}

export default Chip;
